import { ApiService } from "@/api";

export const aggStatusDay = (day: {
  year: string;
  month: string;
  date: string;
}) => {
  return ApiService.baseAction(
    "agg/status/day",
    {
      params: day,
    },
    "GET"
  );
};
